import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import lodash from 'lodash';
import ProviderManager from '../../../provider/providerManager';

export const getMyInvoices = createAsyncThunk('invoices/getMyInvoices', async (data, thunkAPI) => {
  try {
    const providerData = await ProviderManager.getProviderData('invoiceData', {});
    const res = providerData?.Body;
    if (res?.error) {
      return {invoices: [], error: true};
    }
    
    let invoices = res ? res.invoices : [];
    return {invoices: invoices, error: false};
  } catch (error) {
    //case when self Care Data fail
    return {invoices: [], error: true};
  }
});

const initialState = {
  loading: true,
  firstLoading: true,
  error: false,
  visibleBlock: true,
  invoicesList: [],
  previousButton: false,
  absolutelyNew: false,
  activeInvoiceURL: '',
  activeInvoiceUrlType: '',
};

const invoiceComponentBlockSlice = createSlice({
  name: 'invoices',
  initialState: initialState,
  reducers: {
    activeInvoiceOnlineIFrame: (state, action) => {
      return {...state, activeInvoiceURL: action.payload.url, activeInvoiceUrlType: action.payload.type};
    },
  },

  extraReducers: {
    [getMyInvoices.fulfilled]: (state, action) => {
      const {invoices, error} = action.payload;

      let newCustomerCount = lodash.filter(invoices, function (invoice) {
        return invoice.isNewCustomer == true;
      }).length;

      const previousBtnStatus = newCustomerCount == invoices.length || invoices.length == 0 ? false : true;
      const absolutelyNew = newCustomerCount > 0 && newCustomerCount == invoices.length ? true : false;
      const visibleBlock = invoices.length == 1 && invoices[0].invoices.length == 0 && !absolutelyNew ? false : true;
      return {
        ...state,
        visibleBlock: visibleBlock,
        invoicesList: invoices,
        previousButton: previousBtnStatus,
        absolutelyNew: absolutelyNew,
        loading: false,
        error: error,
        firstLoading: false,
      };
    },
  },
});

export const {activeInvoiceOnlineIFrame} = invoiceComponentBlockSlice.actions;
export default invoiceComponentBlockSlice.reducer;
